module.exports = __webpack_public_path__ + "img/er.d049eeaa.svg";